import React, { useMemo } from 'react';
import { TrackingContext, TrackProp, PageVisitProp } from './context';
import { v1 as uuid } from 'uuid';
import { telemetry } from '../tracking/telemetry';
import { differenceInSeconds } from 'date-fns';

const id = uuid();

const trackPage = ({ page, action, time }: PageVisitProp) => {
  let timeSpentInSeconds;
  if (time) {
    timeSpentInSeconds = differenceInSeconds(time.endTime, time.startTime);
  }
  telemetry.sendEvent({ id, page, action, timeSpentInSeconds, type: 'page' });
};

const trackAction = ({ category, action, label, extraInfo }: TrackProp) => {
  telemetry.sendEvent({ id, category, action, label, ...extraInfo });
};

export const TrackingProvider: React.FC<{}> = ({ children }) => {
  const value = useMemo(() => {
    return {
      trackPage,
      trackAction
    };
  }, []);
  return <TrackingContext.Provider value={value}>{children}</TrackingContext.Provider>;
};
